function Panel(_, { slots }) {
    var _a;
    return <div>{(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)}</div>;
}
Panel.displayName = 'Panel';
export default Panel;
